import { useIntl } from 'react-intl';
import Tooltip from './Tooltip';
import { IconButton } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ReactComponent as LinkIcon } from '../../icons/external-link.svg';
import mappedItemTypes from 'services/items/mappedItemTypes';
import { preserveConnectionSearchParams } from 'services/connections';

interface GoToAssetButtonProps {
    itemTypeId: number;
    itemId: number;
    tooltipLabelId?: string;
    tooltipLabel?: string;
}

export function OpenAssetButton({ itemTypeId, itemId, tooltipLabelId, tooltipLabel }: GoToAssetButtonProps) {
    const intl = useIntl();
    const label = tooltipLabelId ? intl.formatMessage({ id: tooltipLabelId }) : tooltipLabel || 'Open Asset';

    const itemTypeConfig = Object.values(mappedItemTypes).find((type) => type.id === itemTypeId);

    if (!itemTypeConfig || !itemTypeConfig.baseRoute) {
        return null;
    }

    const path = `${itemTypeConfig.baseRoute}/${itemId}`;
    const config = preserveConnectionSearchParams(window.location.search);
    const href = `${path}${config ? `?${config}` : ''}`;

    return (
        <Tooltip label={label} isDisabled={false}>
            <IconButton
                as={Link}
                to={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                icon={<LinkIcon />}
                size="sm"
                variant="circular-icon"
            />
        </Tooltip>
    );
}
